import { Button } from 'antd';
import {FormattedMessage, useIntl} from 'react-intl';
import Icon from '../Icon/Icon';
import Popup from '../Popup/Popup';
import styles from './AddRespondents.module.scss';
import {Props} from "./AddRespondents.model";
import SearchForm from "../SearchForm/SearchForm";
import Tag from "../Tag/Tag";
import {Role} from "../../pages/ResourceDetail/ResourceDetail.model";


const AddRespondents = ({ addAllRespondents, addRespondent, onClose, onSearchByTerm, respondents }: Props) => {
	const intl = useIntl();
	const getTagColorByRole = (role: Role) => {
		switch (role) {
			case 'Mentee': return 'grey';
			case 'Mentor': return 'blue';
			case 'ApplicantMentee': return 'grey';
		}
	}

	const renderUser = (participant: any, index: number) => (
		<div className={styles.overflowAuto} key={`Respondent${participant.userId}`}>
			<div className={styles.floatLeft}>
				<div className={styles.participant} key={`mentor${index}`}>
					{participant.imageId ? (
						<div className={styles.avatar}>
							<img alt="Profile" src={participant.imageId} />
						</div>
					) : (
						<div className={styles.circle}>
							<Icon name="user" width="12px" color="text" />
						</div>
					)}
					<div>
						{participant.firstName} {participant.lastName}
						<div>	<Tag color={getTagColorByRole(participant.role)}>{participant.role}</Tag></div>
					</div>
					
				</div>
				
			</div>
			<div className={styles.floatRight}>
				<Button onClick={addRespondent.bind(null, participant)}>
					<FormattedMessage id="buttons.add" />
				</Button>
			</div>
		</div>
	);

	return (
		<Popup
			actions={
				<>
					<Button size="large" onClick={onClose}>
						<FormattedMessage id="buttons.close" />
					</Button>
					<Button size="large" type="primary" onClick={() => {addAllRespondents(); onClose()}}>
						<FormattedMessage id="buttons.addAll" />
					</Button>
				</>
			}
			size="extra-small"
			title={{ target: 'addRespondents' }}
			onClose={onClose}
		>
			<div className={styles.wrapper}>
				<div className={styles.searchContainer}>
					<SearchForm
						searchByTermLabel={intl.formatMessage({
							id: 'formPlaceholders.searchUser',
						})}
						onSearchByTerm={onSearchByTerm}
					/>
				</div>
				{respondents.map((item, index) => renderUser(item, index))}
			</div>
		</Popup>
	);
}

export default AddRespondents;